module.exports = __webpack_public_path__ + "static/gallery2-ee751accb9501312ac4211a6eaaa3823.jpg";